import { Suspense } from 'react';
import { DoughnutChartCardSkeleton } from './components/DoughnutChartCardSkeleton';
import { DoughnutSelectUserCard } from './components/DoughnutSelectUserCard';

type DoughnutChartWithUserSelectSuspense = {
  accountRef?: string | null;
  children: (accountRef: string) => React.ReactNode;
};

export const DoughnutChartWithUserSelectAndSuspenseConatiner = ({
  accountRef,
  children,
}: DoughnutChartWithUserSelectSuspense) => {
  return (
    <Suspense fallback={<DoughnutChartCardSkeleton />}>
      {accountRef ? children(accountRef) : <DoughnutSelectUserCard />}
    </Suspense>
  );
};
